import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Globe } from 'lucide-react';
import { PersonalInfo } from '../../../../types/resume';

interface ContactInfoProps {
  info: PersonalInfo;
  className?: string;
  iconClassName?: string;
  separator?: 'bullet' | 'none';
}

export function ContactInfo({ 
  info, 
  className = '', 
  iconClassName = 'h-3 w-3',
  separator = 'bullet' 
}: ContactInfoProps) {
  return (
    <div className={`flex flex-wrap gap-3 text-sm ${className}`}>
      {info.email && (
        <div className="flex items-center gap-1">
          <Mail className={iconClassName} />
          <span>{info.email}</span>
        </div>
      )}
      {separator === 'bullet' && info.email && info.phone && (
        <span className="text-gray-400">•</span>
      )}
      {info.phone && (
        <div className="flex items-center gap-1">
          <Phone className={iconClassName} />
          <span>{info.phone}</span>
        </div>
      )}
      {separator === 'bullet' && info.phone && info.location && (
        <span className="text-gray-400">•</span>
      )}
      {info.location && (
        <div className="flex items-center gap-1">
          <MapPin className={iconClassName} />
          <span>{info.location}</span>
        </div>
      )}
      {separator === 'bullet' && info.location && info.linkedin && (
        <span className="text-gray-400">•</span>
      )}
      {info.linkedin && (
        <div className="flex items-center gap-1">
          <Linkedin className={iconClassName} />
          <span>{info.linkedin}</span>
        </div>
      )}
      {separator === 'bullet' && info.linkedin && info.website && (
        <span className="text-gray-400">•</span>
      )}
      {info.website && (
        <div className="flex items-center gap-1">
          <Globe className={iconClassName} />
          <span>{info.website}</span>
        </div>
      )}
    </div>
  );
}